import styled from 'styled-components';


/**
 * Scoped CSS reset for the Product Updates component
 *
 * This is needed because Daffy's Base CSS applies lots of styles to the page and they
 * interfere with the content of the Product Updates.
 */
export const ContentReset = styled.div`
  /* Reset all properties */
  all: unset;
  display: block;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;

  /* Reset headings */
  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
  }

  /* Reset paragraphs */
  p {
    margin: 0;
    padding: 0;
    line-height: inherit;
    color: inherit;
  }

  /* Only add bottom margin to top-level paragraphs, not nested ones */
  > p {
    margin-bottom: 1rem;
  }

  /* Reset lists */
  ul, ol {
    margin: 0;
    padding: 0;
    list-style: disc;
  }

  /* Only add bottom margin to top-level lists, not nested ones */
  > ul, > ol {
    margin-bottom: 1rem;
  }

  li {
    margin: 0 1rem;
    margin-bottom: 0.5rem;
    padding: 0;
    line-height: 1.5;
    color: inherit;
  }

  /* Remove bottom margin from last list item to avoid extra spacing */
  li:last-child {
    margin-bottom: 0;
  }

  /* Nested lists should not have bottom margin */
  li ul, li ol {
    margin-bottom: 0;
    margin-top: 0.25rem;
  }

  /* Style nested lists appropriately */
  ul ul {
    list-style: circle;
  }

  ul ul ul {
    list-style: square;
  }

  ol ol {
    list-style: lower-alpha;
  }

  ol ol ol {
    list-style: lower-roman;
  }

  /* Better spacing for nested list items */
  li li {
    margin-bottom: 0.25rem;
  }

  /* Ensure proper spacing between list items and their nested content */
  li > ul, li > ol {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  /* Reset links */
  a {
    color: inherit;
    text-decoration: underline;
    text-transform: none;
    font-weight: unset;
    margin: unset;
    background: none;
  }

  a:hover {
    text-decoration: underline;
  }

  /* Reset text formatting */
  strong, b {
    font-weight: inherit;
  }

  em, i {
    font-style: inherit;
  }

  /* Reset blockquotes */
  blockquote {
    margin: 0;
    padding: 0;
    border: none;
    font-style: inherit;
    line-height: inherit;
    color: inherit;
  }

  /* Reset code elements */
  code {
    font-family: inherit;
    font-size: inherit;
    background: none;
    padding: 0;
    border: none;
    color: inherit;
  }

  pre {
    margin: 0;
    padding: 0;
    font-family: inherit;
    font-size: inherit;
    background: none;
    white-space: pre-wrap;
    line-height: inherit;
    color: inherit;
  }

  /* Reset tables */
  table {
    border-collapse: collapse;
    border-spacing: 0;
    margin: 0;
    padding: 0;
  }

  th, td {
    padding: 0;
    border: none;
    text-align: inherit;
    vertical-align: inherit;
    line-height: inherit;
    color: inherit;
  }

  /* Reset images */
  img {
    max-width: 100%;
    height: auto;
    border: none;
    margin: 0;
    padding: 0;
  }

  /* Reset divs and spans */
  div, span {
    margin: 0;
    padding: 0;
    line-height: inherit;
    color: inherit;
  }

  /* Reset horizontal rules */
  hr {
    margin: 0;
    padding: 0;
    border: none;
    height: 1px;
    background: inherit;
  }

  /* Reset form elements if any */
  input, textarea, select, button {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    color: inherit;
    background: none;
    border: none;
    margin: 0;
    padding: 0;
  }

  /* Set the font size to 14px */
  font-size: 14px;

  /* Reset the margin of the last child to 0 */
  & > :last-child {
    margin-bottom: 0;
  }
`;
